import DraftsRoundedIcon from '@mui/icons-material/DraftsRounded';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import { SxProps, Theme } from '@mui/material';
import { green, red } from '@mui/material/colors';
import InfoBlock from '../../../../components/InfoBlock/InfoBlock';
import AdminViewCard from '../../Components/AdminViewCard';

/**
 * The properties for the unread messages component
 */
interface UnreadMessagesProps {
  /**
   * The number of unread messages
   */
  unreadMessages: number;
}

/**
 * The unread messages component for the home page of the admin dashboard
 */
const UnreadMessagesCard = (props: UnreadMessagesProps) => {
  const iconSx: SxProps<Theme> = {
    height: '24px',
    width: '24px',
  };

  return (
    <AdminViewCard>
      <InfoBlock
        baseId="unread-messages-count"
        title="Messages"
        subtitle={
          props.unreadMessages > 0
            ? `You have ${props.unreadMessages} unread message${
                props.unreadMessages == 1 ? '' : 's'
              }.`
            : 'You have no new messages.'
        }
        icon={
          props.unreadMessages > 0 ? (
            <EmailRoundedIcon sx={iconSx} />
          ) : (
            <DraftsRoundedIcon sx={iconSx} />
          )
        }
        content={`${props.unreadMessages}`}
        color={props.unreadMessages > 0 ? red.A400 : green.A400}
      />
    </AdminViewCard>
  );
};

export default UnreadMessagesCard;
